export default __webpack_public_path__ + "static/media/icon_heart-full.c6d0a9ee.svg";